module.exports = __webpack_public_path__ + "static/img/anxunu06.6275ee7e.png";